/* tslint:disable */
/* eslint-disable */
/**
 * Stututu API
 * REST API for the Stututu car community.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ListBazaarItems200ResponseDataInner
 */
export interface ListBazaarItems200ResponseDataInner {
    /**
     * 
     * @type {number}
     * @memberof ListBazaarItems200ResponseDataInner
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ListBazaarItems200ResponseDataInner
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ListBazaarItems200ResponseDataInner
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ListBazaarItems200ResponseDataInner
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ListBazaarItems200ResponseDataInner
     */
    externalUrl?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ListBazaarItems200ResponseDataInner
     */
    photoUrls?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ListBazaarItems200ResponseDataInner
     */
    priceCents?: number;
    /**
     * 
     * @type {string}
     * @memberof ListBazaarItems200ResponseDataInner
     */
    currency?: string;
    /**
     * 
     * @type {string}
     * @memberof ListBazaarItems200ResponseDataInner
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof ListBazaarItems200ResponseDataInner
     */
    updatedAt?: string;
}

/**
 * Check if a given object implements the ListBazaarItems200ResponseDataInner interface.
 */
export function instanceOfListBazaarItems200ResponseDataInner(value: object): value is ListBazaarItems200ResponseDataInner {
    return true;
}

export function ListBazaarItems200ResponseDataInnerFromJSON(json: any): ListBazaarItems200ResponseDataInner {
    return ListBazaarItems200ResponseDataInnerFromJSONTyped(json, false);
}

export function ListBazaarItems200ResponseDataInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListBazaarItems200ResponseDataInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'description': json['description'] == null ? undefined : json['description'],
        'externalUrl': json['external_url'] == null ? undefined : json['external_url'],
        'photoUrls': json['photo_urls'] == null ? undefined : json['photo_urls'],
        'priceCents': json['price_cents'] == null ? undefined : json['price_cents'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'createdAt': json['created_at'] == null ? undefined : json['created_at'],
        'updatedAt': json['updated_at'] == null ? undefined : json['updated_at'],
    };
}

export function ListBazaarItems200ResponseDataInnerToJSON(json: any): ListBazaarItems200ResponseDataInner {
    return ListBazaarItems200ResponseDataInnerToJSONTyped(json, false);
}

export function ListBazaarItems200ResponseDataInnerToJSONTyped(value?: ListBazaarItems200ResponseDataInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'slug': value['slug'],
        'description': value['description'],
        'external_url': value['externalUrl'],
        'photo_urls': value['photoUrls'],
        'price_cents': value['priceCents'],
        'currency': value['currency'],
        'created_at': value['createdAt'],
        'updated_at': value['updatedAt'],
    };
}

